<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pFrontFlap"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a><a id="pv"></a><a id="pvi"></a>
<div class="copyright">
<p class="center ">Copyright © 1997 by Louis Auchincloss</p>
<p class="center spaceabove1">All rights reserved</p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="center spaceabove1">The Library of Congress has cataloged the print edition as follows:</p>
<p class="center ">Auchincloss, Louis.<br/>
The atonement, and other stories / Louis Auchincloss.<br/>
p. cm.</p>
<p class="center ">Contents: The atonement—Ars gratia artis—The last great divorce—The Maenads—The foursome—Lear’s shadow—The hidden muse—Realist in Babylon—Geraldine</p>
<p class="center "><span class="smallcaps">ISBN</span> 0-395-86826-2</p>
<p class="center ">1. Rich people—United States—Social life and customs—Fiction.<br/>
I. Title.</p>
<p class="center "><span class="smallcaps">PS</span>3501.<span class="smallcaps">U</span>25<span class="smallcaps">A</span>9 1997<br/>
813'.54—dc21 97-14570 <span class="smallcaps">CIP</span></p>
<p class="center spaceabove1">e<span class="smallcaps">ISBN</span> 978-0-547-97115-5<br/>
v2.0421</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?f8d60782